import { render, staticRenderFns } from "./mobile-banking-form.vue?vue&type=template&id=986ccff0&"
import script from "./mobile-banking-form.vue?vue&type=script&lang=js&"
export * from "./mobile-banking-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports